import React, { useState } from 'react';
import { arrayOf, func, node, number, object, shape, string } from 'prop-types';
import classNames from 'classnames';

import { Menu, MenuContent, MenuItem, MenuLabel } from '../../../components';

import css from './SelectSingleFilterPopup.module.css';

const optionLabel = (options, key) => {
  const option = options.find(o => o.key === key);
  return option ? option.label : key;
};

const getQueryParamName = queryParamNames => {
  return Array.isArray(queryParamNames) ? queryParamNames[0] : queryParamNames;
};

function SelectSingleFilterPopup(props) {
  const [isOpen, setIsOpen] = useState(false);

  const {
    rootClassName = null,
    className = null,
    label,
    options,
    queryParamNames,
    initialValues = null,
    contentPlacementOffset = 0,
    onSelect,
  } = props;

  const queryParamName = getQueryParamName(queryParamNames);
  const initialValue =
    initialValues && initialValues[queryParamNames] ? initialValues[queryParamNames] : null;

  const menuLabel = initialValue ? optionLabel(options, initialValue) : label;
  const menuLabelClass = initialValue ? css.menuLabelSelected : css.menuLabel;
  const classes = classNames(rootClassName || css.root, className);

  const handleToggleActive = isOpen => setIsOpen(isOpen);
  const handleSelectOption = (queryParamName, option) => {
    setIsOpen(false);
    onSelect({ [queryParamName]: option });
  };

  return (
    <Menu
      className={classes}
      useArrow={false}
      contentPlacementOffset={contentPlacementOffset}
      onToggleActive={handleToggleActive}
      isOpen={isOpen}
    >
      <MenuLabel rootClassName={menuLabelClass}>{menuLabel}</MenuLabel>
      <MenuContent className={css.menuContent}>
        {options.map(option => {
          const selected = initialValue === option.key;
          const menuItemBorderClass = selected ? css.menuItemBorderSelected : css.menuItemBorder;
          return (
            <MenuItem key={option.key}>
              <button
                className={css.menuItem}
                onClick={() => handleSelectOption(queryParamName, option.key)}
              >
                <span className={menuItemBorderClass} />
                {option.label}
              </button>
            </MenuItem>
          );
        })}
        <MenuItem key={'clearLink'}>
          <button
            className={css.clearMenuItem}
            onClick={() => handleSelectOption(queryParamName, null)}
          >
            Clear selection
          </button>
        </MenuItem>
      </MenuContent>
    </Menu>
  );
}



SelectSingleFilterPopup.propTypes = {
  rootClassName: string,
  className: string,
  queryParamNames: arrayOf(string).isRequired,
  label: node.isRequired,
  onSelect: func.isRequired,
  options: arrayOf(
    shape({
      key: string.isRequired,
      label: string.isRequired,
    })
  ).isRequired,
  initialValues: object,
  contentPlacementOffset: number,
};

export default SelectSingleFilterPopup;
